<template>
  <base-carousel
    :items-carousel="informationDataList"
    :is-loading="!informationDataList"
    :max-elements="1.2"
    :navigation-buttons="false">
    <template #title>
      <div class="secundario text-primary">
        {{ title }}
      </div>
    </template>
    <template #itemCarousel="itemCarouselProps">
      <div>
        <CardUsuarioReserva :grupo="itemCarouselProps.data" class="mx-2" />
      </div>
    </template>
  </base-carousel>
</template>

<script setup>
  import BaseCarousel from '@/components/Carousel/BaseCarousel.vue';
  import CardUsuarioReserva from '@/components/card/Reserva/CardUsuarioReserva.vue';

  defineProps({
    informationDataList: {
      type: Array,
      required: true,
      default: () => null,
    },
    title: {
      type: String,
      required: false,
      default: () => null,
    },
  });
</script>
<style lang="scss" scoped>
  @import '~@/assets/scss/san.scss';
  .secundario {
    font-size: 30px;
    font-weight: 400;
  }

  @include media-breakpoint-down(lg) {
    .secundario {
      font-size: 16px;
      font-weight: 400;
    }
  }
</style>
